import api from './axios';
import { NotificationFeedResponse } from './types';

const notificationApi = {
    getFeed: async (businessId?: string, kind?: string): Promise<NotificationFeedResponse> => {
        const response = await api.get<NotificationFeedResponse>('/notifications/feed', {
            params: {
                ...(businessId ? { business_id: businessId } : {}),
                ...(kind ? { kind } : {}),
            },
        });
        return response.data;
    },

    markRead: async (key: string, businessId?: string, clicked: boolean = true): Promise<void> => {
        await api.patch(`/notifications/feed/${encodeURIComponent(key)}/read`, null, {
            params: {
                clicked,
                ...(businessId ? { business_id: businessId } : {}),
            },
        });
    },

    markAllRead: async (businessId?: string): Promise<void> => {
        await api.patch('/notifications/feed/read-all', null, {
            params: {
                ...(businessId ? { business_id: businessId } : {}),
            },
        });
    },
};

export default notificationApi;
